import { WbDrawer, WbDrawerContent } from '../WbDrawer';
import { MultiSelectionPickerContextProvider } from './MultiSelectionPickerContext';
import { PickerContent, WbMultiSelectionPickerProps } from './PickerContent';

export function WbMultiSelectionPickerDrawer<T>(
  props: WbMultiSelectionPickerProps<T>,
) {
  const {
    open,
    setOpen,
    selectedValues,
    setSelectedValues,
    children,
    title,
    fetchAiData,
  } = props;

  return (
    <WbDrawer open={open} setOpen={setOpen} title={title}>
      <WbDrawerContent
        style={{
          padding: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <MultiSelectionPickerContextProvider<T>
          selectedValues={selectedValues}
          setSelectedValues={setSelectedValues}
          fetchAIData={fetchAiData}
        >
          <PickerContent {...props}>{children}</PickerContent>
        </MultiSelectionPickerContextProvider>
      </WbDrawerContent>
    </WbDrawer>
  );
}
